// Module
var code = "<div class=\"ui-notification\"> <h3 ng-show=\"title\" translate>common.info</h3> <div class=\"message\"> <span translate>user.new-available-version</span><br/> <a href ng-click=\"reloadApp()\" translate>user.new-available-version-install-now</a> </div> </div> ";
// Exports
export default code;